module.exports = __webpack_public_path__ + "static/media/h5_banner_1.601eccc5.png";